import React from "react";
import { ADDITIONAL_DISTRIBUTIONS_CONSTANTS as Labels } from "../../constants/LabelConstants";
import FormPage from "../../components/FormPage/FormPage";
import { AdditionalDistributionLayer, Distribution, DistributionType, DropdownItemType } from "../../model/EstateFlowchartTypes";
import { familyMembersSelector } from "../../slices/EstateFlowChartSlice";
import { useAppSelector } from "../../../store/hooks";
import { getAdditionalDistributionTriggerTitle, resolveTriggerMemberName } from "../../utils/DefUtils";
import "../RemainderBeneficiaries/_remainder-beneficiaries-content.scss";
import DistributionList from "src/EstateFlowchart/components/FormContent/DistributionList/DistributionList";
import { NO_OP } from "src/constants/common";

interface AdditionalDistributionsContentProps {
    pageIndex: number;
    triggerEventData?: AdditionalDistributionLayer;
    saveForm: () => Promise<boolean>;
    distributions?: Distribution[];
    updateEstateItem?: (distributions: Distribution[]) => void;
    addDistributionOptions?: DropdownItemType[];
}

const defaultUpdateEstateItem = (_: Distribution[]): void => {
    NO_OP();
};

const defaultAddDistributionOptions: DropdownItemType[] = [
    { name: "In Trust", type: DistributionType.IN_TRUST },
    { name: "Charity", type: DistributionType.CHARITY },
    { name: "Outright", type: DistributionType.OUTRIGHT }
];

const AdditionalDistributionsContent: React.FC<AdditionalDistributionsContentProps> = ({
    pageIndex,
    triggerEventData,
    saveForm,
    distributions = [],
    updateEstateItem,
    addDistributionOptions = defaultAddDistributionOptions
}: AdditionalDistributionsContentProps): JSX.Element => {
    const rawFamilyMembers = useAppSelector(familyMembersSelector);
    const memberName = triggerEventData
        ? resolveTriggerMemberName(
            rawFamilyMembers,
            triggerEventData.triggerMemberId,
            triggerEventData.triggerMemberName
        )
        : undefined;
    const title = triggerEventData
        ? getAdditionalDistributionTriggerTitle(triggerEventData, memberName)
        : "Additional Distribution Layer";

    return (
        <FormPage title={title} subText={Labels.TITLE_SUB_TEXT} pageIndex={pageIndex}>
            <DistributionList
                distributions={distributions}
                updateEstateItem={updateEstateItem ?? defaultUpdateEstateItem}
                saveForm={saveForm}
                pageIndex={pageIndex}
                addDistributionOptions={addDistributionOptions}
            />
        </FormPage>
    );
};

export default AdditionalDistributionsContent;